<template>
  <b-form @submit.stop.prevent="onSubmit">
    <b-row>
      <b-col>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">ชื่อกลุ่ม*</label>
              <b-form-input
                v-model="$v.name.$model"
                type="text"
                id="name"
                placeholder="ตัวอย่าง: 6 ล้อตู้ วิ่งงานภาคกลาง"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                aria-describedby="name-live-feedback"
                @focus="onFormFocus('name')"
              ></b-form-input>
              <b-form-invalid-feedback id="name-live-feedback">จำเป็นต้องระบุ</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="searchName">เชิญสมาชิก</label>
              <b-input-group>
                <b-form-input
                  v-model="searchName"
                  type="text"
                  id="searchName"
                  placeholder="ตัวอย่าง: สุขสวัสดิ์ขนส่ง"
                ></b-form-input>
                <b-input-group-append>
                  <b-button v-on:click="searchCompany" variant="primary">ค้นหา</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="searchResult.length > 0">
          <b-col sm="12">
            <b-form-group label="ผลการค้นหา">
              <b-form-checkbox
                v-for="option in searchResult"
                v-model="searchSelected"
                :key="option._id"
                :value="option._id"
                stacked
              >{{ option.name }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="selectList.length > 0">
          <b-col sm="12">
            <b-form-group label="สมาชิกในกลุ่ม">
              <b-form-checkbox
                v-for="option in selectList"
                v-model="searchSelected"
                :key="option._id"
                :value="option._id"
                stacked
                @input="onFormFocus('members')"
              >{{ option.name }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span
              class="logisty-custom-invalid-feedbace"
              v-if="searchSelected.length < 1"
            >เลือกสมาชิกอย่างน้อย 1 ราย</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="align-items-center mt-2">
      <b-col class="pb-2">
        <!-- <b-button type="submit" variant="primary">บันทึก</b-button> -->
      </b-col>
      <!-- <b-col class="pb-2">
        <b-button v-on:click="goBack" variant="warning">ยกเลิก</b-button>
      </b-col>-->
    </b-row>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, decimal, integer } from 'vuelidate/lib/validators'
import Company from '../../services/http/Company'

export default {
  name: 'DashboardMygroupMainForm',
  props: ['updateId'],
  mixins: [validationMixin],
  validations: {
    name: {
      required
    }
  },
  data () {
    return {
      name: null,
      searchName: null,
      companylist: [],
      searchResult: [],
      searchSelected: [],
      selectList: []
    }
  },
  mounted () {
    this.init()
    Window.Event.$on('saveGroupForm', this.onSubmit)
  },
  beforeDestroy () {
    Window.Event.$off('saveGroupForm')
  },
  methods: {
    async init () {
      var company = new Company()
      try {
        var companies = await company.getCompanyAll()
        if (companies.code === 1) {
          this.companylist = companies.data
        }
      } catch (error) {
        console.log(error)
        return
      }

      if (this.updateId) {
        this.prepareUpdate()
      }
    },
    async prepareUpdate () {
      var company = new Company()
      try {
        var vendorGroup = await company.getVendorGroup(this.updateId)
        if (vendorGroup.code === 1) {
          this.name = vendorGroup.data.name
          this.searchSelected = vendorGroup.data.members.map(x => x._id)
        }
      } catch (error) {
        console.log(error)
      }
    },
    searchCompany () {
      this.updateMemberForm()
    },
    updateMemberForm () {
      this.updateSearchResult()
      this.updateList()
    },
    updateSearchResult () {
      this.searchResult = this.companylist.filter(
        (company) => {
          if (company.name && company.name.includes(this.searchName)) {
            return company
          }
        }
      )
    },
    updateList () {
      // console.log(this.searchSelected)
      var list = []
      for (var i = 0; i < this.searchSelected.length; i++) {
        list.push(this.companylist.find(
          x => x._id === this.searchSelected[i]
        ))
      }

      this.selectList = list

      var newList = this.searchResult
      for (var i = 0; i < this.searchSelected.length; i++) {
        newList = newList.filter(
          x => x._id !== this.searchSelected[i]
        )
      }
      // console.log(newList)
      this.searchResult = newList
    },
    async onSubmit () {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }

      if (this.searchSelected.length > 0) {
        // do post create vendor group
        var company = new Company()
        var jsonData = {
          name: this.name,
          members: this.searchSelected
        }
        try {
          if (!this.updateId) {
            var vendorGroup = await company.createVendorGroup(jsonData)
          } else {
            jsonData['vendorGroupId'] = this.updateId
            var vendorGroup = await company.updateVendorGroup(jsonData)
          }
        } catch (error) {
          console.log(error)
          return
        }

        if (vendorGroup.code === 1) {
          // alert('สำเร็จ')
          this.$emit('groupProcressed')
        } else {
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        }
      }
    },
    goBack () {
      this.$router.back()
    },
    onFormFocus (name) {
      if (this.updateId) {
        window.analytics.track('group-update-form-focus-' + name)
      } else {
        window.analytics.track('group-create-form-focus-' + name)
      }
    }
  },
  watch: {
    searchSelected (newVal, oldVal) {
      // this.searchCompany()
      this.updateMemberForm()
    }
  }
}
</script>
